const formulyRachunekPrzeplywowDM = [
  { poleSumy: 0, polaSkladowe: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] }, //1+2
  { poleSumy: 2, polaSkladowe: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
  {
    poleSumy: 13,
    polaSkladowe: [
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      -27,
      -28,
      -29,
      -30,
      -31,
      -32,
      -33,
      -34,
      -35,
    ],
  }, //14-26
  { poleSumy: 14, polaSkladowe: [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25] },
  { poleSumy: 26, polaSkladowe: [27, 28, 29, 30, 31, 32, 33, 34, 35] },
  {
    poleSumy: 36,
    polaSkladowe: [
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      -47,
      -48,
      -49,
      -50,
      -51,
      -52,
      -53,
      -54,
      -55,
      -56,
      -57,
      -58,
      -59,
    ],
  }, //37-46
  { poleSumy: 37, polaSkladowe: [38, 39, 40, 41, 42, 43, 44, 45] },
  {
    poleSumy: 46,
    polaSkladowe: [47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
  },
  {
    poleSumy: 60,
    polaSkladowe: [
      1,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      -27,
      -28,
      -29,
      -30,
      -31,
      -32,
      -33,
      -34,
      -35,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      -47,
      -48,
      -49,
      -50,
      -51,
      -52,
      -53,
      -54,
      -55,
      -56,
      -57,
      -58,
      -59,
    ],
  }, //0+13+36
  {
    poleSumy: 64,
    polaSkladowe: [
      1,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      -27,
      -28,
      -29,
      -30,
      -31,
      -32,
      -33,
      -34,
      -35,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      -47,
      -48,
      -49,
      -50,
      -51,
      -52,
      -53,
      -54,
      -55,
      -56,
      -57,
      -58,
      -59,
      63,
    ],
  }, //60+63
]

const formulyRachunekPrzeplywowPosredni = [
  { poleSumy: 2, polaSkladowe: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
  { poleSumy: 20, polaSkladowe: [21, 22, 23, 24, 25] },
  { poleSumy: 18, polaSkladowe: [19, 21, 22, 23, 24, 25] }, // 19 + 20
  { poleSumy: 15, polaSkladowe: [16, 17, 19, 21, 22, 23, 24, 25, 26] }, // 16 + 17 + 18 + 26
  { poleSumy: 33, polaSkladowe: [34, 35] },
  { poleSumy: 30, polaSkladowe: [31, 34, 35] }, // 31 + 33
  { poleSumy: 27, polaSkladowe: [28, 29, 31, 34, 35, 36] }, // 28 + 29 + 30 + 35
  { poleSumy: 39, polaSkladowe: [40, 41, 42, 43] },
  { poleSumy: 44, polaSkladowe: [45, 46, 47, 48, 49, 50, 51, 52, 53] },

  { poleSumy: 13, polaSkladowe: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
  {
    poleSumy: 0,
    polaSkladowe: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  },

  {
    poleSumy: 37,
    polaSkladowe: [
      16,
      17,
      19,
      21,
      22,
      23,
      24,
      25,
      26,
      -28,
      -29,
      -31,
      -34,
      -35,
      -36,
    ],
  }, // 15 - 27
  {
    poleSumy: 14,
    polaSkladowe: [
      16,
      17,
      19,
      21,
      22,
      23,
      24,
      25,
      26,
      -28,
      -29,
      -31,
      -34,
      -35,
      -36,
    ],
  },

  {
    poleSumy: 54,
    polaSkladowe: [40, 41, 42, 43, -45, -46, -47, -48, -49, -50, -51, -52, -53],
  }, // 39 - 44
  {
    poleSumy: 38,
    polaSkladowe: [40, 41, 42, 43, -45, -46, -47, -48, -49, -50, -51, -52, -53],
  },

  {
    poleSumy: 55,
    polaSkladowe: [
      1,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      16,
      17,
      19,
      21,
      22,
      23,
      24,
      25,
      26,
      -28,
      -29,
      -31,
      -34,
      -35,
      -36,
      40,
      41,
      42,
      43,
      -45,
      -46,
      -47,
      -48,
      -49,
      -50,
      -51,
      -52,
      -53,
    ],
  }, // 13 + 39 + 54

  {
    poleSumy: 59,
    polaSkladowe: [
      1,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      16,
      17,
      19,
      21,
      22,
      23,
      24,
      25,
      26,
      -28,
      -29,
      -31,
      -34,
      -35,
      -36,
      40,
      41,
      42,
      43,
      -45,
      -46,
      -47,
      -48,
      -49,
      -50,
      -51,
      -52,
      -53,
      58,
    ],
  }, // 55 + 58
]

const formulyRachunekPrzeplywowBezposredni = [
  { poleSumy: 17, polaSkladowe: [18, 19, 20, 21, 22] },
  { poleSumy: 15, polaSkladowe: [16, 18, 19, 20, 21, 22] }, // 16 + 17
  { poleSumy: 30, polaSkladowe: [31, 32] },
  { poleSumy: 27, polaSkladowe: [28, 31, 32] }, // 28 + 30
  { poleSumy: 1, polaSkladowe: [2, 3] },
  { poleSumy: 4, polaSkladowe: [5, 6, 7, 8, 9] },

  { poleSumy: 10, polaSkladowe: [2, 3, -5, -6, -7, -8, -9] }, // 1 - 4
  {
    poleSumy: 0,
    polaSkladowe: [2, 3, -5, -6, -7, -8, -9],
  }, // 1 + 4

  { poleSumy: 12, polaSkladowe: [13, 14, 16, 18, 19, 20, 21, 22, 23] },
  { poleSumy: 24, polaSkladowe: [25, 26, 28, 31, 32, 33] },

  {
    poleSumy: 34,
    polaSkladowe: [
      13,
      14,
      16,
      18,
      19,
      20,
      21,
      22,
      23,
      -25,
      -26,
      -28,
      -31,
      -32,
      -33,
    ],
  }, // 12 - 24
  {
    poleSumy: 11,
    polaSkladowe: [
      13,
      14,
      16,
      18,
      19,
      20,
      21,
      22,
      23,
      -25,
      -26,
      -28,
      -31,
      -32,
      -33,
    ],
  },

  { poleSumy: 36, polaSkladowe: [37, 38, 39, 40] },
  { poleSumy: 41, polaSkladowe: [42, 43, 44, 45, 46, 47, 48, 49, 50] },

  {
    poleSumy: 51,
    polaSkladowe: [37, 38, 39, 40, -42, -43, -44, -45, -46, -47, -48, -49, -50],
  }, // 36 - 41
  {
    poleSumy: 35,
    polaSkladowe: [37, 38, 39, 40, -42, -43, -44, -45, -46, -47, -48, -49, -50],
  },

  {
    poleSumy: 52,
    polaSkladowe: [
      2,
      3,
      -5,
      -6,
      -7,
      -8,
      -9,
      13,
      14,
      16,
      18,
      19,
      20,
      21,
      22,
      23,
      -25,
      -26,
      -28,
      -31,
      -32,
      -33,
      37,
      38,
      39,
      40,
      -42,
      -43,
      -44,
      -45,
      -46,
      -47,
      -48,
      -49,
      -50,
    ],
  }, // 10 + 34 + 51

  {
    poleSumy: 56,
    polaSkladowe: [
      2,
      3,
      -5,
      -6,
      -7,
      -8,
      -9,
      13,
      14,
      16,
      18,
      19,
      20,
      21,
      22,
      23,
      -25,
      -26,
      -28,
      -31,
      -32,
      -33,
      37,
      38,
      39,
      40,
      -42,
      -43,
      -44,
      -45,
      -46,
      -47,
      -48,
      -49,
      -50,
      55,
    ],
  }, // 55 + 52
]

const formulySkonsolidowanyRachunekPrzeplywowPosredni = [
  {
    poleSumy: 0,
    polaSkladowe: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
  }, //|17|
  {
    poleSumy: 2,
    polaSkladowe: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
  },
  {
    poleSumy: 17,
    polaSkladowe: [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
  }, //1+2
  {
    poleSumy: 18,
    polaSkladowe: [
      20,
      21,
      23,
      25,
      26,
      27,
      28,
      29,
      30,
      -32,
      -33,
      -35,
      -37,
      -38,
      -39,
      -40,
    ],
  }, //|41|
  { poleSumy: 19, polaSkladowe: [20, 21, 23, 25, 26, 27, 28, 29, 30] }, //20+21+22+30
  { poleSumy: 22, polaSkladowe: [23, 25, 26, 27, 28, 29] }, //23+24
  { poleSumy: 24, polaSkladowe: [25, 26, 27, 28, 29] },
  { poleSumy: 31, polaSkladowe: [32, 33, 35, 37, 38, 39, 40] }, //32+33+34+39+40
  { poleSumy: 34, polaSkladowe: [35, 37, 38] }, //35+36
  { poleSumy: 36, polaSkladowe: [37, 38] },
  {
    poleSumy: 41,
    polaSkladowe: [
      20,
      21,
      23,
      25,
      26,
      27,
      28,
      29,
      30,
      -32,
      -33,
      -35,
      -37,
      -38,
      -39,
      -40,
    ],
  }, //19-31
  {
    poleSumy: 42,
    polaSkladowe: [44, 45, 46, 47, -49, -50, -51, -52, -53, -54, -55, -56, -57],
  }, //|58|
  { poleSumy: 43, polaSkladowe: [44, 45, 46, 47] },
  { poleSumy: 48, polaSkladowe: [49, 50, 51, 52, 53, 54, 55, 56, 57] },
  {
    poleSumy: 58,
    polaSkladowe: [44, 45, 46, 47, -49, -50, -51, -52, -53, -54, -55, -56, -57],
  }, //43-48
  {
    poleSumy: 59,
    polaSkladowe: [
      1,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      20,
      21,
      23,
      25,
      26,
      27,
      28,
      29,
      30,
      -32,
      -33,
      -35,
      -37,
      -38,
      -39,
      -40,
      44,
      45,
      46,
      47,
      -49,
      -50,
      -51,
      -52,
      -53,
      -54,
      -55,
      -56,
      -57,
    ],
  }, //17+41+58
  {
    poleSumy: 63,
    polaSkladowe: [
      1,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      20,
      21,
      23,
      25,
      26,
      27,
      28,
      29,
      30,
      -32,
      -33,
      -35,
      -37,
      -38,
      -39,
      -40,
      44,
      45,
      46,
      47,
      -49,
      -50,
      -51,
      -52,
      -53,
      -54,
      -55,
      -56,
      -57,
      62,
    ],
  }, //59+62
]

const formulySkonsolidowanyRachunekPrzeplywowBezposredni = [
  {
    poleSumy: 0,
    polaSkladowe: [2, 3, -5, -6, -7, -8, -9],
  }, // 1 + 4
  { poleSumy: 1, polaSkladowe: [2, 3] },
  { poleSumy: 4, polaSkladowe: [5, 6, 7, 8, 9] },
  { poleSumy: 10, polaSkladowe: [2, 3, -5, -6, -7, -8, -9] }, // 1 - 4
  {
    poleSumy: 11,
    polaSkladowe: [
      13,
      14,
      16,
      18,
      19,
      20,
      21,
      22,
      23,
      -25,
      -26,
      -28,
      -30,
      -31,
      -32,
      -33,
    ],
  },

  { poleSumy: 12, polaSkladowe: [13, 14, 16, 18, 19, 20, 21, 22, 23] },
  { poleSumy: 15, polaSkladowe: [16, 18, 19, 20, 21, 22] }, // 16 + 17
  { poleSumy: 17, polaSkladowe: [18, 19, 20, 21, 22] },
  { poleSumy: 24, polaSkladowe: [25, 26, 28, 30, 31, 32, 33] },
  { poleSumy: 27, polaSkladowe: [28, 30, 31] }, // 28 + 29
  { poleSumy: 29, polaSkladowe: [30, 31] },
  {
    poleSumy: 34,
    polaSkladowe: [
      13,
      14,
      16,
      18,
      19,
      20,
      21,
      22,
      23,
      -25,
      -26,
      -28,
      -30,
      -31,
      -32,
      -33,
    ],
  }, // 12 - 24
  {
    poleSumy: 35,
    polaSkladowe: [37, 38, 39, 40, -42, -43, -44, -45, -46, -47, -48, -49, -50],
  },
  { poleSumy: 36, polaSkladowe: [37, 38, 39, 40] },
  { poleSumy: 41, polaSkladowe: [42, 43, 44, 45, 46, 47, 48, 49, 50] },
  {
    poleSumy: 51,
    polaSkladowe: [37, 38, 39, 40, -42, -43, -44, -45, -46, -47, -48, -49, -50],
  }, // 36 - 41
  {
    poleSumy: 52,
    polaSkladowe: [
      2,
      3,
      -5,
      -6,
      -7,
      -8,
      -9,
      13,
      14,
      16,
      18,
      19,
      20,
      21,
      22,
      23,
      -25,
      -26,
      -28,
      -30,
      -31,
      -32,
      -33,
      37,
      38,
      39,
      40,
      -42,
      -43,
      -44,
      -45,
      -46,
      -47,
      -48,
      -49,
      -50,
    ],
  }, // 10 + 34 + 51
  {
    poleSumy: 56,
    polaSkladowe: [
      2,
      3,
      -5,
      -6,
      -7,
      -8,
      -9,
      13,
      14,
      16,
      18,
      19,
      20,
      21,
      22,
      23,
      -25,
      -26,
      -28,
      -30,
      -31,
      -32,
      -33,
      37,
      38,
      39,
      40,
      -42,
      -43,
      -44,
      -45,
      -46,
      -47,
      -48,
      -49,
      -50,
      55,
    ],
  }, // 52 + 55
]

const formulyZestawienieZmianWKapitale = [
  { poleSumy: 3, polaSkladowe: [0, 1, 2] },
  { poleSumy: 5, polaSkladowe: [6, -8] },
  { poleSumy: 10, polaSkladowe: [4, 6, -8] }, // 4 + 5
  { poleSumy: 12, polaSkladowe: [13, -17] },
  { poleSumy: 19, polaSkladowe: [11, 13, -17] }, // 11 + 12
  { poleSumy: 21, polaSkladowe: [22, -23] },
  { poleSumy: 25, polaSkladowe: [20, 22, -23] }, // 20 + 21
  { poleSumy: 27, polaSkladowe: [28, -29] },
  { poleSumy: 30, polaSkladowe: [26, 28, -29] }, // 26 + 27
  {
    poleSumy: 32,
    polaSkladowe: [31],
    warunek: x => x > 0,
    polaSkladoweBis: [],
  },
  {
    poleSumy: 35,
    polaSkladowe: [
      {
        poleSumy: 32,
        polaSkladowe: [31],
        warunek: x => x > 0,
        polaSkladoweBis: [],
      },
      -33,
      -34,
    ],
  },
  {
    poleSumy: 39,
    polaSkladowe: [
      {
        poleSumy: 32,
        polaSkladowe: [31],
        warunek: x => x > 0,
        polaSkladoweBis: [],
      },
      -33,
      -34,
      36,
      -38,
    ],
  },
  {
    poleSumy: 40,
    polaSkladowe: [31],
    warunek: x => x < 0,
    polaSkladoweBis: [],
  },
  {
    poleSumy: 43,
    polaSkladowe: [
      {
        poleSumy: 40,
        polaSkladowe: [31],
        warunek: x => x < 0,
        polaSkladoweBis: [],
      },
      41,
      42,
    ],
  }, // 40+41+42
  {
    poleSumy: 47,
    polaSkladowe: [
      {
        poleSumy: 40,
        polaSkladowe: [31],
        warunek: x => x < 0,
        polaSkladoweBis: [],
      },
      41,
      42,
      44,
      46,
    ],
  }, // 43+44+56
  {
    poleSumy: 48,
    polaSkladowe: [
      {
        poleSumy: 32,
        polaSkladowe: [31],
        warunek: x => x > 0,
        polaSkladoweBis: [],
      },
      -33,
      -34,
      36,
      -38,
    ],
    warunek: x => x > 0,
    polaSkladoweBis: [
      {
        poleSumy: 40,
        polaSkladowe: [31],
        warunek: x => x < 0,
        polaSkladoweBis: [],
      },
      41,
      42,
      44,
      46,
    ],
  },
  {
    poleSumy: 49,
    polaSkladowe: [50, 51, 52],
  },
  {
    poleSumy: 53,
    polaSkladowe: [
      4,
      6,
      -8,
      11,
      13,
      -17,
      20,
      22,
      -23,
      26,
      28,
      -29,
      {
        poleSumy: 48,
        polaSkladowe: [
          {
            poleSumy: 32,
            polaSkladowe: [31],
            warunek: x => x > 0,
            polaSkladoweBis: [],
          },
          -33,
          -34,
          36,
          -38,
        ],
        warunek: x => x > 0,
        polaSkladoweBis: [
          {
            poleSumy: 40,
            polaSkladowe: [31],
            warunek: x => x < 0,
            polaSkladoweBis: [],
          },
          41,
          42,
          44,
          46,
        ],
      },
      50,
      51,
      52,
    ],
  }, // 10 + 19 + 25 + 30 + 48 + 49
]

const formulySkonsolidowaneZestawienieZmianWKapitale = [
  { poleSumy: 2, polaSkladowe: [0, 1] },
  { poleSumy: 4, polaSkladowe: [5, -7] },
  { poleSumy: 9, polaSkladowe: [3, 5, -7] }, // 3+4
  { poleSumy: 11, polaSkladowe: [12, -16] },
  { poleSumy: 18, polaSkladowe: [10, 12, -16] }, // 10+11
  { poleSumy: 20, polaSkladowe: [21, -22] },
  { poleSumy: 24, polaSkladowe: [19, 21, -22] }, // 19+20
  { poleSumy: 26, polaSkladowe: [27, -28] },
  { poleSumy: 29, polaSkladowe: [25, 27, -28] }, // 25+26
  {
    poleSumy: 32,
    polaSkladowe: [31],
    warunek: x => x > 0,
    polaSkladoweBis: [],
  },
  {
    poleSumy: 35,
    polaSkladowe: [
      {
        poleSumy: 32,
        polaSkladowe: [31],
        warunek: x => x > 0,
        polaSkladoweBis: [],
      },
      -33,
      -34,
    ],
  }, // 32-33-34
  {
    poleSumy: 39,
    polaSkladowe: [
      {
        poleSumy: 32,
        polaSkladowe: [31],
        warunek: x => x > 0,
        polaSkladoweBis: [],
      },
      -33,
      -34,
      36,
      -38,
    ],
  },
  {
    poleSumy: 40,
    polaSkladowe: [31],
    warunek: x => x < 0,
    polaSkladoweBis: [],
  },
  {
    poleSumy: 43,
    polaSkladowe: [
      {
        poleSumy: 40,
        polaSkladowe: [31],
        warunek: x => x < 0,
        polaSkladoweBis: [],
      },
      41,
      42,
    ],
  }, // 40+41+43
  {
    poleSumy: 47,
    polaSkladowe: [
      {
        poleSumy: 40,
        polaSkladowe: [31],
        warunek: x => x < 0,
        polaSkladoweBis: [],
      },
      41,
      42,
      44,
      46,
    ],
  },
  {
    poleSumy: 48,
    polaSkladowe: [
      {
        poleSumy: 32,
        polaSkladowe: [31],
        warunek: x => x > 0,
        polaSkladoweBis: [],
      },
      -33,
      -34,
      36,
      -38,
    ],
    warunek: x => x > 0,
    polaSkladoweBis: [
      {
        poleSumy: 40,
        polaSkladowe: [31],
        warunek: x => x < 0,
        polaSkladoweBis: [],
      },
      41,
      42,
      44,
      46,
    ],
  },
  {
    poleSumy: 49,
    polaSkladowe: [50, 51, 52],
  },
  {
    poleSumy: 53,
    polaSkladowe: [
      3,
      5,
      -7,
      10,
      12,
      -16,
      19,
      21,
      -22,
      25,
      27,
      -28,
      {
        poleSumy: 48,
        polaSkladowe: [
          {
            poleSumy: 32,
            polaSkladowe: [31],
            warunek: x => x > 0,
            polaSkladoweBis: [],
          },
          -33,
          -34,
          36,
          -38,
        ],
        warunek: x => x > 0,
        polaSkladoweBis: [
          {
            poleSumy: 40,
            polaSkladowe: [31],
            warunek: x => x < 0,
            polaSkladoweBis: [],
          },
          41,
          42,
          44,
          46,
        ],
      },
      50,
      51,
      52,
    ],
  }, // 9+18+24+29+48+49
]

const formulyBilansInnaAktywa = [
  {
    poleSumy: 0,
    polaSkladowe: [
      3,
      4,
      5,
      6,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      17,
      18,
      19,
      21,
      22,
      25,
      26,
      27,
      28,
      30,
      31,
      32,
      33,
      35,
      36,
      37,
      38,
      39,
      41,
      42,
      45,
      46,
      47,
      48,
      49,
      53,
      54,
      55,
      58,
      59,
      60,
      63,
      64,
      65,
      66,
      67,
      71,
      72,
      73,
      74,
      76,
      77,
      78,
      79,
      81,
      82,
      83,
      84,
      85,
      86,
      87,
    ],
  }, // 1+43+86+87
  {
    poleSumy: 1,
    polaSkladowe: [
      3,
      4,
      5,
      6,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      17,
      18,
      19,
      21,
      22,
      25,
      26,
      27,
      28,
      30,
      31,
      32,
      33,
      35,
      36,
      37,
      38,
      39,
      41,
      42,
    ],
  }, // 2+7+16+20+40
  { poleSumy: 2, polaSkladowe: [3, 4, 5, 6] },
  { poleSumy: 7, polaSkladowe: [9, 10, 11, 12, 13, 14, 15] }, // 8+14+15
  { poleSumy: 8, polaSkladowe: [9, 10, 11, 12, 13] },
  { poleSumy: 16, polaSkladowe: [17, 18, 19] },
  {
    poleSumy: 20,
    polaSkladowe: [21, 22, 25, 26, 27, 28, 30, 31, 32, 33, 35, 36, 37, 38, 39],
  }, // 21+22+23+39
  {
    poleSumy: 23,
    polaSkladowe: [25, 26, 27, 28, 30, 31, 32, 33, 35, 36, 37, 38],
  }, // 24+29+34
  { poleSumy: 24, polaSkladowe: [25, 26, 27, 28] },
  { poleSumy: 29, polaSkladowe: [30, 31, 32, 33] },
  { poleSumy: 34, polaSkladowe: [35, 36, 37, 38] },
  { poleSumy: 40, polaSkladowe: [41, 42] },
  {
    poleSumy: 43,
    polaSkladowe: [
      45,
      46,
      47,
      48,
      49,
      53,
      54,
      55,
      58,
      59,
      60,
      63,
      64,
      65,
      66,
      67,
      71,
      72,
      73,
      74,
      76,
      77,
      78,
      79,
      81,
      82,
      83,
      84,
      85,
    ],
  }, // 44+50+68+85
  { poleSumy: 44, polaSkladowe: [45, 46, 47, 48, 49] },
  { poleSumy: 50, polaSkladowe: [53, 54, 55, 58, 59, 60, 63, 64, 65, 66, 67] }, // 51+56+61
  { poleSumy: 51, polaSkladowe: [53, 54, 55] }, // 52+55
  { poleSumy: 52, polaSkladowe: [53, 54] },
  { poleSumy: 56, polaSkladowe: [58, 59, 60] }, // 57+60
  { poleSumy: 57, polaSkladowe: [58, 59] },
  { poleSumy: 61, polaSkladowe: [63, 64, 65, 66, 67] }, // 62+65+66+67
  { poleSumy: 62, polaSkladowe: [63, 64] },
  {
    poleSumy: 68,
    polaSkladowe: [71, 72, 73, 74, 76, 77, 78, 79, 81, 82, 83, 84],
  }, // 69+84
  { poleSumy: 69, polaSkladowe: [71, 72, 73, 74, 76, 77, 78, 79, 81, 82, 83] }, // 70+75+80
  { poleSumy: 70, polaSkladowe: [71, 72, 73, 74] },
  { poleSumy: 75, polaSkladowe: [76, 77, 78, 79] },
  { poleSumy: 80, polaSkladowe: [81, 82, 83] },
]

const formulyBilansInnaPasywa = [
  {
    poleSumy: 0,
    polaSkladowe: [
      2, 3, 7, 9, 14, 19, 20,
      23, 25, 26, 28, 29,
      31, 32, 34, 35, 36, 37, 38,
      42, 43, 44, 
      47, 48, 49,
      51, 52, 53, 55, 56, 57, 58, 59, 60, 61,
      62,
      64, 66, 67,
    ],
  }, // 1+21
  { poleSumy: 1, polaSkladowe: [2, 3, 7, 9, 14, 19, 20] }, //2+3+7+9+14+19+20
  {
    poleSumy: 21,
    polaSkladowe: [
      23, 25, 26, 28, 29,
      31, 32, 34, 35, 36, 37, 38,
      42, 43, 44, 
      47, 48, 49,
      51, 52, 53, 55, 56, 57, 58, 59, 60, 61,
      62,
      64, 66, 67
    ],
  }, // 22+30+39+63
  { poleSumy: 22, polaSkladowe: [23, 25, 26, 28, 29] }, // 23+24+27
  { poleSumy: 24, polaSkladowe: [25, 26] },
  { poleSumy: 27, polaSkladowe: [28, 29] },
  { poleSumy: 30, polaSkladowe: [31, 32, 34, 35, 36, 37, 38] }, // 31+32+33
  { poleSumy: 33, polaSkladowe: [34, 35, 36, 37, 38] },
  {
    poleSumy: 39,
    polaSkladowe: [
      42, 43, 44, 
      47, 48, 49,
      51, 52, 53, 55, 56, 57, 58, 59, 60, 61,
      62,
    ],
  }, // 40+45+50+62
  { poleSumy: 40, polaSkladowe: [42, 43, 44] }, // 41+ 44
  { poleSumy: 41, polaSkladowe: [42, 43] },
  { poleSumy: 45, polaSkladowe: [47, 48, 49] }, // 46+49
  { poleSumy: 46, polaSkladowe: [47, 48] },
  { poleSumy: 50, polaSkladowe: [51, 52, 53, 55, 56, 57, 58, 59, 60, 61] }, // 51+52+53+ 54+ 57+58+59+60+61
  { poleSumy: 54, polaSkladowe: [55, 56] },
  { poleSumy: 63, polaSkladowe: [64, 66, 67] }, // 64 + 65
  { poleSumy: 65, polaSkladowe: [66, 67] },
]

const formulyInnaRZiSKalkulacyjny = [
  { poleSumy: 0, polaSkladowe: [2, 3] },
  { poleSumy: 4, polaSkladowe: [6, 7] },
  { poleSumy: 8, polaSkladowe: [2, 3, -6, -7] }, //0+4
  { poleSumy: 11, polaSkladowe: [2, 3, -6, -7, -9, -10] }, //0+4-8
  { poleSumy: 12, polaSkladowe: [13, 14, 15, 16] },
  { poleSumy: 17, polaSkladowe: [18, 19, 20] },
  {
    poleSumy: 21,
    polaSkladowe: [2, 3, -6, -7, -9, -10, 13, 14, 15, 16, -18, -19, -20],
  }, //11+12-13
  { poleSumy: 22, polaSkladowe: [24, 26, 28, 30, 32, 33] }, //23+26+28+30+32+33
  { poleSumy: 23, polaSkladowe: [24, 26] },
  { poleSumy: 34, polaSkladowe: [35, 37, 39, 40] },
  {
    poleSumy: 41,
    polaSkladowe: [
      2,
      3,
      -6,
      -7,
      -9,
      -10,
      13,
      14,
      15,
      16,
      -18,
      -19,
      -20,
      24,
      26,
      28,
      30,
      32,
      33,
      -35,
      -37,
      -39,
      -40,
    ],
  }, //21+22-34
  {
    poleSumy: 44,
    polaSkladowe: [
      2,
      3,
      -6,
      -7,
      -9,
      -10,
      13,
      14,
      15,
      16,
      -18,
      -19,
      -20,
      24,
      26,
      28,
      30,
      32,
      33,
      -35,
      -37,
      -39,
      -40,
      -42,
      -43,
    ],
  }, //41-42-43
]

const formulyInnaRZiSPorownawczy = [
  { poleSumy: 0, polaSkladowe: [2, 3, 4, 5, 6] },
  { poleSumy: 7, polaSkladowe: [8, 9, 10, 11, 13, 14, 16, 17] },
  {
    poleSumy: 18,
    //0-7
    polaSkladowe: [
      2, 3, 4, 5, 6, 
      -8, -9, -10, -11, -13, -14, -16, -17,
    ],
  }, 
  { poleSumy: 19, polaSkladowe: [20, 21, 22, 23] },
  { poleSumy: 24, polaSkladowe: [25, 26, 27] },
  {
    poleSumy: 28,
    //18+19-24
    polaSkladowe: [
      2, 3, 4, 5, 6, 
      -8, -9, -10, -11, -13, -14, -16, -17,   
      20, 21, 22, 23,
      -25, -26, -27,
    ],
  }, 
  { poleSumy: 29, polaSkladowe: [31, 33, 35, 37, 39, 40] }, 
  { poleSumy: 30, polaSkladowe: [31, 33] },
  { poleSumy: 41, polaSkladowe: [42, 44, 46, 47] },
  {
    poleSumy: 48,
    //28+29-41
    polaSkladowe: [
      2, 3, 4, 5, 6, 
      -8, -9, -10, -11, -13, -14, -16, -17,   
      20, 21, 22, 23,
      -25, -26, -27,
      31, 33, 35, 37, 39, 40,
      -42, -44, -46, -47,
    ],
  }, 
  {
    poleSumy: 51,
    //48-49-50
    polaSkladowe: [
      2, 3, 4, 5, 6, 
      -8, -9, -10, -11, -13, -14, -16, -17,   
      20, 21, 22, 23,
      -25, -26, -27,
      31, 33, 35, 37, 39, 40,
      -42, -44, -46, -47,
      -49,
      -50,
    ],
  }, 
]

const formulyMikroRZiS_v1 = [
  {
    poleSumy: 2,
    polaSkladowe: [3, 4, 5, 6],
  },
  { poleSumy: 12, polaSkladowe: [0, -3, -4, -5, -6, 7, -9, -11] },
]

const formulyMikroRZiS_v2 = [
  {
    poleSumy: 2,
    polaSkladowe: [3, 4, 5, 6],
  },
  { poleSumy: 12, polaSkladowe: [0, -3, -4, -5, -6, 7, -9, -11] },
  {
    poleSumy: 13,
    polaSkladowe: [0, -3, -4, -5, -6, 7, -9, -11],
    warunek: x => x >= 0,
  },
  {
    poleSumy: 14,
    polaSkladowe: [0, -3, -4, -5, -6, 7, -9, -11],
    warunek: x => x < 0,
  },
]

const formulyBilansMikroAktywa = [{ poleSumy: 0, polaSkladowe: [1, 2, 5, 6] }]

const formulyBilansMikroPasywa = [{ poleSumy: 0, polaSkladowe: [1, 3] }]

const formulyBilansMalaAktywa = [
  { poleSumy: 0, polaSkladowe: [2, 3, 6, 7, 10, 12, 13, 17, 20, 21, 22] }, // 1+11+21+22
  { poleSumy: 1, polaSkladowe: [2, 3, 6, 7, 10] },
  { poleSumy: 11, polaSkladowe: [12, 13, 17, 20] },
]

const formulyBilansMalaPasywa = [
  { poleSumy: 0, polaSkladowe: [2, 3, 5, 7, 8, 9, 10, 12, 14, 16, 22] }, // 1+11
  { poleSumy: 1, polaSkladowe: [2, 3, 5, 7, 8, 9, 10] },
  { poleSumy: 11, polaSkladowe: [12, 14, 16, 22] },
]

const formulyBilansOpAktywa = [
  { poleSumy: 0, polaSkladowe: [2, 3, 4, 5, 6, 8, 9, 10, 11, 12] }, // 1+7+12
  { poleSumy: 1, polaSkladowe: [2, 3, 4, 5, 6] },
  { poleSumy: 7, polaSkladowe: [8, 9, 10, 11] },
]

const formulyBilansOpPasywa = [
  { poleSumy: 0, polaSkladowe: [2, 3, 4, 5, 7, 8, 9, 10] }, // 1+6
  { poleSumy: 1, polaSkladowe: [2, 3, 4, 5] },
  { poleSumy: 6, polaSkladowe: [7, 8, 9, 10] },
]

const formulyMalaRZiSPorownawczy = [
  { poleSumy: 0, polaSkladowe: [1, 2, 3] },
  { poleSumy: 4, polaSkladowe: [5, 6, 7, 8, 9, 11] },
  { poleSumy: 13, polaSkladowe: [1, 2, 3, -5, -6, -7, -8, -9, -11] }, // 0-4
  {
    poleSumy: 32,
    polaSkladowe: [1, 2, 3, -5, -6, -7, -8, -9, -11, 14, -16, 18, -26],
  }, // 13+14-16+18-26
  {
    poleSumy: 34,
    polaSkladowe: [1, 2, 3, -5, -6, -7, -8, -9, -11, 14, -16, 18, -26, -33],
  }, //32-33
]

const formulyMalaRZiSKalkulacyjny = [
  { poleSumy: 4, polaSkladowe: [0, -1, -2, -3] },
  { poleSumy: 23, polaSkladowe: [0, -1, -2, -3, 5, -7, 9, -17] }, // 4+5+7+9-17
  { poleSumy: 25, polaSkladowe: [0, -1, -2, -3, 5, -7, 9, -17, -24] }, // 23-24
]

const formulyOpRZiS = [
  { poleSumy: 0, polaSkladowe: [1, 2, 3] },
  { poleSumy: 4, polaSkladowe: [5, 6, 7] },
  { poleSumy: 8, polaSkladowe: [1, 2, 3, -5, -6, -7] },
  { poleSumy: 11, polaSkladowe: [9, -10] },
  { poleSumy: 13, polaSkladowe: [1, 2, 3, -5, -6, -7, 9, -10, -12] },
  {
    poleSumy: 18,
    polaSkladowe: [1, 2, 3, -5, -6, -7, 9, -10, -12, 14, -15, 16, -17],
  },
  {
    poleSumy: 20,
    polaSkladowe: [1, 2, 3, -5, -6, -7, 9, -10, -12, 14, -15, 16, -17, -19],
  },
]

const formulySkonsolidowanyRZiSKalkulacyjny = [
  { poleSumy: 0, polaSkladowe: [2, 3] },
  { poleSumy: 4, polaSkladowe: [6, 7] },
  { poleSumy: 8, polaSkladowe: [2, 3, -6, -7] }, // 0-4
  { poleSumy: 11, polaSkladowe: [2, 3, -6, -7, -9, -10] }, //8-9-10
  { poleSumy: 12, polaSkladowe: [13, 14, 15, 16] },
  { poleSumy: 17, polaSkladowe: [18, 19, 20] },
  {
    poleSumy: 21,
    polaSkladowe: [2, 3, -6, -7, -9, -10, 13, 14, 15, 16, -18, -19, -20], //11+12-17
  },
  { poleSumy: 22, polaSkladowe: [23, 28, 30, 32, 33] },
  { poleSumy: 34, polaSkladowe: [35, 37, 39, 40] },
  {
    poleSumy: 42,
    polaSkladowe: [
      2,
      3,
      -6,
      -7,
      -9,
      -10,
      13,
      14,
      15,
      16,
      -18,
      -19,
      -20,
      23,
      28,
      30,
      32,
      33,
      -35,
      -37,
      -39,
      -40,
      41,
    ],
  }, //21+22-34+41
  { poleSumy: 43, polaSkladowe: [44, 45] },
  { poleSumy: 46, polaSkladowe: [47, 48] },
  {
    poleSumy: 50,
    polaSkladowe: [
      2,
      3,
      -6,
      -7,
      -9,
      -10,
      13,
      14,
      15,
      16,
      -18,
      -19,
      -20,
      23,
      28,
      30,
      32,
      33,
      -35,
      -37,
      -39,
      -40,
      41,
      -44,
      -45,
      47,
      48,
      49,
    ],
  }, //42-43+46+49
  {
    poleSumy: 54,
    polaSkladowe: [
      2,
      3,
      -6,
      -7,
      -9,
      -10,
      13,
      14,
      15,
      16,
      -18,
      -19,
      -20,
      23,
      28,
      30,
      32,
      33,
      -35,
      -37,
      -39,
      -40,
      41,
      -44,
      -45,
      47,
      48,
      49,
      -51,
      -52,
      53,
    ],
  }, //50-51-52+53
]

const formulySkonsolidowanyRZiSPorownawczy = [
  { poleSumy: 0, polaSkladowe: [2, 3, 4, 5] },
  { poleSumy: 6, polaSkladowe: [7, 8, 9, 10, 12, 13, 15, 16] },
  {
    poleSumy: 17,
    polaSkladowe: [2, 3, 4, 5, -7, -8, -9, -10, -12, -13, -15, -16],
  }, //0-6
  { poleSumy: 18, polaSkladowe: [19, 20, 21, 22] },
  { poleSumy: 23, polaSkladowe: [24, 25, 26] },
  {
    poleSumy: 27,
    polaSkladowe: [
      2,
      3,
      4,
      5,
      -7,
      -8,
      -9,
      -10,
      -12,
      -13,
      -15,
      -16,
      19,
      20,
      21,
      22,
      -24,
      -25,
      -26,
    ],
  }, //17+18-23
  { poleSumy: 28, polaSkladowe: [29, 34, 36, 38, 39] },
  { poleSumy: 40, polaSkladowe: [41, 43, 45, 46] },
  {
    poleSumy: 48,
    polaSkladowe: [
      2,
      3,
      4,
      5,
      -7,
      -8,
      -9,
      -10,
      -12,
      -13,
      -15,
      -16,
      19,
      20,
      21,
      22,
      -24,
      -25,
      -26,
      29,
      34,
      36,
      38,
      39,
      -41,
      -43,
      -45,
      -46,
      47,
    ],
  }, //27+28-40+47
  { poleSumy: 49, polaSkladowe: [50, 51] },
  { poleSumy: 52, polaSkladowe: [53, 54] },
  {
    poleSumy: 56,
    polaSkladowe: [
      2,
      3,
      4,
      5,
      -7,
      -8,
      -9,
      -10,
      -12,
      -13,
      -15,
      -16,
      19,
      20,
      21,
      22,
      -24,
      -25,
      -26,
      29,
      34,
      36,
      38,
      39,
      -41,
      -43,
      -45,
      -46,
      47,
      -50,
      -51,
      53,
      54,
      55,
    ],
  }, //48-49+52+55
  {
    poleSumy: 60,
    polaSkladowe: [
      2,
      3,
      4,
      5,
      -7,
      -8,
      -9,
      -10,
      -12,
      -13,
      -15,
      -16,
      19,
      20,
      21,
      22,
      -24,
      -25,
      -26,
      29,
      34,
      36,
      38,
      39,
      -41,
      -43,
      -45,
      -46,
      47,
      -50,
      -51,
      53,
      54,
      55,
      -57,
      -58,
      59,
    ],
  }, //56-57-58+59
]

const formulySkonsolidowanyBilansAktywa = [
  {
    poleSumy: 0,
    polaSkladowe: [
      3,
      4,
      5,
      6,
      8,
      9,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      20,
      21,
      22,
      24,
      25,
      28,
      29,
      30,
      31,
      33,
      34,
      35,
      36,
      38,
      39,
      40,
      41,
      43,
      44,
      45,
      46,
      47,
      49,
      50,
      53,
      54,
      55,
      56,
      57,
      61,
      62,
      63,
      66,
      67,
      68,
      71,
      72,
      73,
      74,
      75,
      77,
      97,
      98,
      99,
      100,
    ],
  }, // 1+51+99+100
  {
    poleSumy: 1,
    polaSkladowe: [
      3,
      4,
      5,
      6,
      8,
      9,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      20,
      21,
      22,
      24,
      25,
      28,
      29,
      30,
      31,
      33,
      34,
      35,
      36,
      38,
      39,
      40,
      41,
      43,
      44,
      45,
      46,
      47,
      49,
      50,
    ],
  }, // 2+7+10+19+23+48
  { poleSumy: 2, polaSkladowe: [3, 4, 5, 6] },
  { poleSumy: 7, polaSkladowe: [8, 9] }, // ??
  { poleSumy: 10, polaSkladowe: [12, 13, 14, 15, 16, 17, 18] }, // 11+17+18
  { poleSumy: 11, polaSkladowe: [12, 13, 14, 15, 16] },
  { poleSumy: 19, polaSkladowe: [20, 21, 22] },
  {
    poleSumy: 23,
    polaSkladowe: [
      24,
      25,
      28,
      29,
      30,
      31,
      33,
      34,
      35,
      36,
      38,
      39,
      40,
      41,
      43,
      44,
      45,
      46,
      47,
    ],
  }, //24+ 25+26+ 47
  {
    poleSumy: 26,
    polaSkladowe: [
      28,
      29,
      30,
      31,
      33,
      34,
      35,
      36,
      38,
      39,
      40,
      41,
      43,
      44,
      45,
      46,
    ],
  }, //27+32+37+42
  { poleSumy: 27, polaSkladowe: [28, 29, 30, 31] },
  { poleSumy: 32, polaSkladowe: [33, 34, 35, 36] },
  { poleSumy: 37, polaSkladowe: [38, 39, 40, 41] },
  { poleSumy: 42, polaSkladowe: [43, 44, 45, 46] },
  { poleSumy: 48, polaSkladowe: [49, 50] },
  {
    poleSumy: 51,
    polaSkladowe: [
      53,
      54,
      55,
      56,
      57,
      61,
      62,
      63,
      66,
      67,
      68,
      71,
      72,
      73,
      74,
      75,
      77,
      97,
      98,
    ],
  }, // 52+58+76+98
  { poleSumy: 52, polaSkladowe: [53, 54, 55, 56, 57] },
  { poleSumy: 58, polaSkladowe: [61, 62, 63, 66, 67, 68, 71, 72, 73, 74, 75] }, // 59+64+69
  { poleSumy: 59, polaSkladowe: [61, 62, 63] }, // 60+63
  { poleSumy: 60, polaSkladowe: [61, 62] },
  { poleSumy: 64, polaSkladowe: [66, 67, 68] }, // 65+68
  { poleSumy: 65, polaSkladowe: [66, 67] },
  { poleSumy: 69, polaSkladowe: [71, 72, 73, 74, 75] }, // 70+73+74+75
  { poleSumy: 70, polaSkladowe: [71, 72] },
  { poleSumy: 76, polaSkladowe: [77, 97] },
  { poleSumy: 78, polaSkladowe: [79, 80, 81, 82] },
  { poleSumy: 83, polaSkladowe: [84, 85, 86, 87] },
  { poleSumy: 88, polaSkladowe: [89, 90, 91, 92] },
  { poleSumy: 93, polaSkladowe: [94, 95, 96] },
]

const formulySkonsolidowanyBilansPasywa = [
  {
    poleSumy: 0,
    polaSkladowe: [
      2,
      3,
      5,
      7,
      9,
      10,
      11,
      12,
      13,
      14,
      19,
      21,
      22,
      24,
      25,
      27,
      28,
      30,
      31,
      32,
      33,
      34,
      38,
      39,
      40,
      43,
      44,
      45,
      47,
      48,
      49,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      60,
      62,
      63,
    ],
  }, // 1+13+14+17
  { poleSumy: 1, polaSkladowe: [2, 3, 5, 7, 9, 10, 11, 12] },
  {
    poleSumy: 17,
    polaSkladowe: [
      19,
      21,
      22,
      24,
      25,
      27,
      28,
      30,
      31,
      32,
      33,
      34,
      38,
      39,
      40,
      43,
      44,
      45,
      47,
      48,
      49,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      60,
      62,
      63,
    ],
  }, // 18+26+35+59
  { poleSumy: 18, polaSkladowe: [19, 21, 22, 24, 25] }, // 19+20+23
  { poleSumy: 20, polaSkladowe: [21, 22] },
  { poleSumy: 23, polaSkladowe: [24, 25] },
  { poleSumy: 26, polaSkladowe: [27, 28, 30, 31, 32, 33, 34] }, // 27+28+29
  { poleSumy: 29, polaSkladowe: [30, 31, 32, 33, 34] },
  {
    poleSumy: 35,
    polaSkladowe: [
      38,
      39,
      40,
      43,
      44,
      45,
      47,
      48,
      49,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
    ],
  }, // 36+41+46+58
  { poleSumy: 36, polaSkladowe: [38, 39, 40] }, // 37+40
  { poleSumy: 37, polaSkladowe: [38, 39] },
  { poleSumy: 41, polaSkladowe: [43, 44, 45] }, // 42+45
  { poleSumy: 42, polaSkladowe: [43, 44] },
  { poleSumy: 46, polaSkladowe: [47, 48, 49, 51, 52, 53, 54, 55, 56, 57] }, // 47+48+49+50+53+54+55+56+57
  { poleSumy: 50, polaSkladowe: [51, 52] },
  { poleSumy: 59, polaSkladowe: [60, 62, 63] }, // 60+61
  { poleSumy: 61, polaSkladowe: [62, 63] },
]

const formulyBilansDomMaklerskiAktywa = [
  {
    poleSumy: 0,
    polaSkladowe: [
      2,
      3,
      4,
      5,
      7,
      8,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      33,
      34,
      35,
      36,
      37,
      39,
      40,
      41,
      42,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      58,
      59,
      60,
      61,
      62,
      64,
      65,
      67,
      68,
      71,
      72,
      73,
      74,
      75,
      76,
      78,
      79,
      80,
      81,
    ],
  }, // 1, 6, 22, 31, 32, 38, 43, 56, 57, 63, 69, 77, 80, 81
  { poleSumy: 1, polaSkladowe: [2, 3, 4, 5] },
  {
    poleSumy: 6,
    polaSkladowe: [7, 8, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
  }, //7, 8, 9, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21
  { poleSumy: 9, polaSkladowe: [10, 11] },
  { poleSumy: 22, polaSkladowe: [23, 24, 25, 26, 27, 28, 29, 30] },
  { poleSumy: 32, polaSkladowe: [33, 34, 35, 36, 37] },
  { poleSumy: 38, polaSkladowe: [39, 40, 41, 42] },
  { poleSumy: 43, polaSkladowe: [45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55] }, // 44+50+51+53+54+55
  { poleSumy: 44, polaSkladowe: [45, 46, 47, 48, 49] },
  { poleSumy: 57, polaSkladowe: [58, 59, 60, 61, 62] },
  { poleSumy: 63, polaSkladowe: [64, 65, 67, 68] },
  { poleSumy: 69, polaSkladowe: [71, 72, 73, 74, 75, 76] }, // 70+75+76
  { poleSumy: 70, polaSkladowe: [71, 72, 73, 74] },
  { poleSumy: 77, polaSkladowe: [78, 79] },
]

const formulyBilansDomMaklerskiPasywa = [
  {
    poleSumy: 0,
    polaSkladowe: [
      2,
      3,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,

      26,
      27,
      29,
      30,
      31,
      32,
      34,
      35,
      36,

      38,
      40,
      41,

      43,
      45,
      46,
      48,
      49,

      50,

      52,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      62,
      63,
      64,
      65,
    ],
  }, // 1+24+37+42+50+51
  {
    poleSumy: 1,
    polaSkladowe: [
      2,
      3,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
    ],
  }, // 2,3,4,7,8,9,10,11,12,15,16,17,18,19,20,21,22,23
  { poleSumy: 4, polaSkladowe: [5, 6] },
  { poleSumy: 12, polaSkladowe: [13, 14] },
  { poleSumy: 24, polaSkladowe: [26, 27, 29, 30, 31, 32, 34, 35, 36] }, // 25,28,31,32,33,36
  { poleSumy: 25, polaSkladowe: [26, 27] },
  { poleSumy: 28, polaSkladowe: [29, 30] },
  { poleSumy: 33, polaSkladowe: [34, 35] },
  { poleSumy: 37, polaSkladowe: [38, 40, 41] }, //38+39
  { poleSumy: 39, polaSkladowe: [40, 41] },
  { poleSumy: 42, polaSkladowe: [43, 45, 46, 48, 49] }, // 43+44+47
  { poleSumy: 44, polaSkladowe: [45, 46] },
  { poleSumy: 47, polaSkladowe: [48, 49] },
  {
    poleSumy: 51,
    polaSkladowe: [52, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65],
  }, // 52,53,59,60,61,64,65
  { poleSumy: 53, polaSkladowe: [54, 55, 56, 57, 58] },
  { poleSumy: 61, polaSkladowe: [62, 63] },
]

const formulyPozycjePozabilansowe = [
  { poleSumy: 0, polaSkladowe: [1, 2, 3, 4] },
]

const formulyRZiSDomMaklerski = [
  { poleSumy: 0, polaSkladowe: [3, 4, 5, 6, 7, 8, 9, 10, 11] }, //2+11
  { poleSumy: 2, polaSkladowe: [3, 4, 5, 6, 7, 8, 9, 10] },
  {
    poleSumy: 12,
    polaSkladowe: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
  },
  {
    poleSumy: 27,
    polaSkladowe: [
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      -13,
      -14,
      -15,
      -16,
      -17,
      -18,
      -19,
      -20,
      -21,
      -22,
      -23,
      -24,
      -25,
      -26,
    ],
  }, // 0-12
  { poleSumy: 28, polaSkladowe: [29, 31, 33, 34, 35] },
  { poleSumy: 36, polaSkladowe: [37, 38, 39] },
  { poleSumy: 40, polaSkladowe: [29, 31, 33, 34, 35, -37, -38, -39] }, // 28-36
  { poleSumy: 41, polaSkladowe: [42, 44, 45, 46, 47] },
  { poleSumy: 48, polaSkladowe: [49, 50, 51, 52] },
  { poleSumy: 53, polaSkladowe: [42, 44, 45, 46, 47, -49, -50, -51, -52] }, // 41-48
  { poleSumy: 54, polaSkladowe: [55, 57, 59, 60, 61, 62] },
  { poleSumy: 63, polaSkladowe: [64, 65, 66, 67] },
  { poleSumy: 68, polaSkladowe: [55, 57, 59, 60, 61, 62, -64, -65, -66, -67] }, // 54-63
  { poleSumy: 69, polaSkladowe: [70, 71, 72, 73, 74] },
  { poleSumy: 75, polaSkladowe: [76, 77, 78, 79, 80] },
  {
    poleSumy: 81,
    polaSkladowe: [
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      -13,
      -14,
      -15,
      -16,
      -17,
      -18,
      -19,
      -20,
      -21,
      -22,
      -23,
      -24,
      -25,
      -26,
      29,
      31,
      33,
      34,
      35,
      -37,
      -38,
      -39,
      42,
      44,
      45,
      46,
      47,
      -49,
      -50,
      -51,
      -52,
      55,
      57,
      59,
      60,
      61,
      62,
      -64,
      -65,
      -66,
      -67,
      70,
      71,
      72,
      73,
      74,
      -76,
      -77,
      -78,
      -79,
      -80,
    ],
  }, // 27+40+53+68+69-75
  { poleSumy: 82, polaSkladowe: [83, 85, 87, 89, 90, 91] }, //83, 85, 87, 88, 91
  { poleSumy: 88, polaSkladowe: [89, 90] },
  { poleSumy: 92, polaSkladowe: [93, 95, 97, 98, 99] },
  { poleSumy: 96, polaSkladowe: [97, 98] },
  {
    poleSumy: 100,
    polaSkladowe: [
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      -13,
      -14,
      -15,
      -16,
      -17,
      -18,
      -19,
      -20,
      -21,
      -22,
      -23,
      -24,
      -25,
      -26,
      29,
      31,
      33,
      34,
      35,
      -37,
      -38,
      -39,
      42,
      44,
      45,
      46,
      47,
      -49,
      -50,
      -51,
      -52,
      55,
      57,
      59,
      60,
      61,
      62,
      -64,
      -65,
      -66,
      -67,
      70,
      71,
      72,
      73,
      74,
      -76,
      -77,
      -78,
      -79,
      -80,
      83,
      85,
      87,
      89,
      90,
      91,
      -93,
      -95,
      -97,
      -98,
      -99,
    ],
  }, // 81+82-92
  {
    poleSumy: 103,
    polaSkladowe: [
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      -13,
      -14,
      -15,
      -16,
      -17,
      -18,
      -19,
      -20,
      -21,
      -22,
      -23,
      -24,
      -25,
      -26,
      29,
      31,
      33,
      34,
      35,
      -37,
      -38,
      -39,
      42,
      44,
      45,
      46,
      47,
      -49,
      -50,
      -51,
      -52,
      55,
      57,
      59,
      60,
      61,
      62,
      -64,
      -65,
      -66,
      -67,
      70,
      71,
      72,
      73,
      74,
      -76,
      -77,
      -78,
      -79,
      -80,
      83,
      85,
      87,
      89,
      90,
      91,
      -93,
      -95,
      -97,
      -98,
      -99,
      -101,
      -102,
    ],
  }, // 100-101-102
]

const formulyZZwKDomMaklerski = [
  { poleSumy: 3, polaSkladowe: [0, 1, 2] },
  { poleSumy: 5, polaSkladowe: [6, -8] },
  { poleSumy: 10, polaSkladowe: [4, 6, -8] }, //4+5
  { poleSumy: 12, polaSkladowe: [13, -17] },
  { poleSumy: 19, polaSkladowe: [11, 13, -17] }, //11+12
  { poleSumy: 21, polaSkladowe: [22, -23] },
  { poleSumy: 25, polaSkladowe: [20, 22, -23] }, // 20+21
  { poleSumy: 27, polaSkladowe: [28, -29] },
  { poleSumy: 30, polaSkladowe: [26, 28, -29] }, // 26+27
  {
    poleSumy: 32,
    polaSkladowe: [31],
    warunek: x => x > 0,
    polaSkladoweBis: [],
  },
  {
    poleSumy: 35,
    polaSkladowe: [
      {
        poleSumy: 32,
        polaSkladowe: [31],
        warunek: x => x > 0,
        polaSkladoweBis: [],
      },
      -33,
      -34,
    ],
  },
  {
    poleSumy: 39,
    polaSkladowe: [
      {
        poleSumy: 32,
        polaSkladowe: [31],
        warunek: x => x > 0,
        polaSkladoweBis: [],
      },
      -33,
      -34,
      36,
      -38,
    ],
  }, // 35+36-38
  {
    poleSumy: 40,
    polaSkladowe: [31],
    warunek: x => x < 0,
    polaSkladoweBis: [],
  },
  {
    poleSumy: 43,
    polaSkladowe: [
      {
        poleSumy: 40,
        polaSkladowe: [31],
        warunek: x => x < 0,
        polaSkladoweBis: [],
      },
      41,
      42,
    ],
  }, // 40+41+42
  {
    poleSumy: 47,
    polaSkladowe: [
      {
        poleSumy: 40,
        polaSkladowe: [31],
        warunek: x => x < 0,
        polaSkladoweBis: [],
      },
      41,
      42,
      44,
      46,
    ],
  }, // 43+44+46
  {
    poleSumy: 48,
    polaSkladowe: [
      {
        poleSumy: 32,
        polaSkladowe: [31],
        warunek: x => x > 0,
        polaSkladoweBis: [],
      },
      -33,
      -34,
      36,
      -38,
    ],
    warunek: x => x > 0,
    polaSkladoweBis: [
      {
        poleSumy: 40,
        polaSkladowe: [31],
        warunek: x => x < 0,
        polaSkladoweBis: [],
      },
      41,
      42,
      44,
      46,
    ],
  },
  {
    poleSumy: 49,
    polaSkladowe: [50, 51, 52],
  },
  {
    poleSumy: 53,
    polaSkladowe: [
      4,
      6,
      -8,
      11,
      13,
      -17,
      20,
      22,
      -23,
      26,
      28,
      -29,
      {
        poleSumy: 48,
        polaSkladowe: [
          {
            poleSumy: 32,
            polaSkladowe: [31],
            warunek: x => x > 0,
            polaSkladoweBis: [],
          },
          -33,
          -34,
          36,
          -38,
        ],
        warunek: x => x > 0,
        polaSkladoweBis: [
          {
            poleSumy: 40,
            polaSkladowe: [31],
            warunek: x => x < 0,
            polaSkladoweBis: [],
          },
          41,
          42,
          44,
          46,
        ],
      },
      50,
      51,
      52,
    ],
  }, //10+19+25+30+48+49
]

export {
  formulyRachunekPrzeplywowPosredni,
  formulyRachunekPrzeplywowBezposredni,
  formulyRachunekPrzeplywowDM,
  formulyZestawienieZmianWKapitale,
  formulySkonsolidowaneZestawienieZmianWKapitale,
  formulyBilansInnaAktywa,
  formulyBilansInnaPasywa,
  formulyBilansMikroAktywa,
  formulyBilansMikroPasywa,
  formulyInnaRZiSKalkulacyjny,
  formulyInnaRZiSPorownawczy,
  formulyBilansMalaAktywa,
  formulyBilansMalaPasywa,
  formulyBilansOpAktywa,
  formulyBilansOpPasywa,
  formulyBilansDomMaklerskiAktywa,
  formulyBilansDomMaklerskiPasywa,
  formulyRZiSDomMaklerski,
  formulyMikroRZiS_v1,
  formulyMikroRZiS_v2,
  formulyPozycjePozabilansowe,
  formulyMalaRZiSPorownawczy,
  formulyMalaRZiSKalkulacyjny,
  formulyOpRZiS,
  formulyZZwKDomMaklerski,
  formulySkonsolidowanyRZiSKalkulacyjny,
  formulySkonsolidowanyRZiSPorownawczy,
  formulySkonsolidowanyBilansAktywa,
  formulySkonsolidowanyBilansPasywa,
  formulySkonsolidowanyRachunekPrzeplywowPosredni,
  formulySkonsolidowanyRachunekPrzeplywowBezposredni,
}
